import { combineReducers } from "redux";

import { CoachingNoteCategoriesActions } from "./categories/actions";
import categories, {
  CoachingNoteCategoriesState,
  initialCoachingNoteCategoriesState,
} from "./categories/reducers";
import { CoachingFilesActions } from "./files/actions";
import files, { CoachingFilesState, initialCoachingFilesState } from "./files/reducers";
import { CoachingNotesActions } from "./notes/actions";
import notes, { CoachingNotesState, initialCoachingNotesState } from "./notes/reducers";
import { CoachingNoteWithTaskActions } from "./noteWithTask/actions";
import noteWithTask, {
  CoachingNoteWithTaskState,
  initialCoachingNoteWithTaskState,
} from "./noteWithTask/reducers";
import { CoachingTasksActions } from "./tasks/actions";
import tasks, { CoachingTasksState, initialCoachingTasksState } from "./tasks/reducers";

export interface CoachingState {
  categories: CoachingNoteCategoriesState;
  files: CoachingFilesState;
  notes: CoachingNotesState;
  noteWithTask: CoachingNoteWithTaskState;
  tasks: CoachingTasksState;
}

export const initialCoachingState: CoachingState = {
  categories: initialCoachingNoteCategoriesState,
  files: initialCoachingFilesState,
  notes: initialCoachingNotesState,
  noteWithTask: initialCoachingNoteWithTaskState,
  tasks: initialCoachingTasksState,
};

export type CoachingActions =
  | CoachingFilesActions
  | CoachingNoteCategoriesActions
  | CoachingNotesActions
  | CoachingNoteWithTaskActions
  | CoachingTasksActions;

// Single source of truth for sub-reducers.
const subReducers = {
  categories,
  files,
  notes,
  noteWithTask,
  tasks,
};

export const coachingActionTypes = Object.values(subReducers).flatMap((reducer) =>
  Object.keys(reducer.handlers)
) as CoachingActions["type"][];

const coaching = combineReducers<CoachingState>(subReducers);

export default coaching;
